import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { SEOLandingList } from 'app/typings/SEOLanding';
import { apiRequest } from 'app/utils/request/api';
import type { SortOrder } from 'app/utils/sort';

export const path = '/landings' as const;

export type UseGetSEOLandingsOptionsType = {
  search?: string;
  sorting?: SortOrder;
  pageNumber?: number;
  isPublished?: boolean;
};

export function useSEOLandings(options?: UseGetSEOLandingsOptionsType) {
  const { search, sorting, pageNumber, isPublished } = options || {};

  const { data, isFetching } = useQuery<SEOLandingList[]>({
    queryKey: ['landings', search, sorting, pageNumber, isPublished],
    queryFn: () =>
      apiRequest({
        path,
        queryParams: {
          search,
          sorting,
          pageNumber,
          isPublished,
        },
      }),
    staleTime: 0,
    placeholderData: keepPreviousData,
  });

  return {
    data,
    isFetching,
  };
}
